/*
 * @Author: EdwardYoung
 * @Date: 2017-07-25 23:09:58
 * @Last Modified by: EdwardYoung
 * @Last Modified time: 2017-08-23 01:06:14
 */

import axios from 'api/axios.js'
import {createApiHeader} from './createApiHeader.js'
import {bargainForMyFriends} from './bargainHelpFriends'
import {localstorageSetItem} from 'common/util/localstorageUtil'

function bargainForMyself (id) {
  return new Promise((resolve, reject) => {
    window.yhsd.ready(function (sdk) {
      sdk.account.current(function (User) {
        createApiHeader(axios, User.res.customer)
        _bargainForMyself(id, User.res.customer).then((res) => {
          return res.data.data
        }).then(playData => {
          return bargainForMyFriends(playData.id).then((helpData) => {
            localstorageSetItem('playerId', playData.id)
            localstorageSetItem('campaignId', id)
            resolve(helpData)
          })
        }).catch((err) => {
          reject(err.response.data.message)
        })
      })
    })
  })
}

/**
 * 为自己砍价
 */
function _bargainForMyself (id, customer) {
  const activityInfUrl = `/v1/front/play_records/${id}`
  return axios({
    method: 'POST',
    url: activityInfUrl,
    data: {
      avatar: customer.avatar_url,
      name: customer.name
    }
  })
}

export {bargainForMyself}



// WEBPACK FOOTER //
// ./src/api/bargainForMyself.js